import * as angular from "angular";
import {CommissionPaymentDetailsModel} from "../models/commission-payment-details.model";
import {ConsolidatedCommissionModel} from "../models/consolidated-commission.model";
import {ExportConsolidatedCommissionTablePayloadModel} from "../models/consolidated-commission-table-export-payload.model";
import {ExportConsolidatedCommissionsTranslationsPayloadModel} from "../types/export-consolidated-commissions-translations-payload.model";

export class ConsolidatedCommissionRequestsService {

  /* @ngInject */
  constructor(private $consolidatedCommission, private ConsolidateCommissionsApi) {
  }

  // ******************************
  // External methods
  // ******************************

  getOne(id) {
    const api = this.ConsolidateCommissionsApi.actions.getOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  create(consolidatedCommissionPayload: ConsolidatedCommissionModel) {
    const api = this.ConsolidateCommissionsApi.actions.create;
    return this.$$call(api, {}, consolidatedCommissionPayload, {});
  }

  update(id, consolidatedCommission: ConsolidatedCommissionModel) {
    const api = this.ConsolidateCommissionsApi.actions.update;
    return this.$$call(api, {}, consolidatedCommission, {id: id});
  }

  delete(id: string) {
    const api = this.ConsolidateCommissionsApi.actions.delete;
    return this.$$call(api, {}, {}, {id: id});
  }

  addCommissions(id: string, payload) {
    const api = this.ConsolidateCommissionsApi.actions.addCommissions;
    return this.$$call(api, {}, payload, {id: id});
  }

  removeCommissions(id: string, commissionIds: string[]) {
    const api = this.ConsolidateCommissionsApi.actions.removeCommissions;
    return this.$$call(api, {commissionId: commissionIds}, {}, {id: id});
  }

  payManually(id, commissionPaymentDetails: CommissionPaymentDetailsModel) {
    const api = this.ConsolidateCommissionsApi.actions.payManually;
    return this.$$call(api, {}, commissionPaymentDetails, {id: id});
  }

  pay(id, commissionPaymentDetails: CommissionPaymentDetailsModel) {
    const api = this.ConsolidateCommissionsApi.actions.pay;
    return this.$$call(api, {}, commissionPaymentDetails, {id: id});
  }

  exportTableCSV(payload: ExportConsolidatedCommissionTablePayloadModel) {
    const api = this.ConsolidateCommissionsApi.actions.exportTableCSV;
    return this.$$call(api, {}, payload, {});
  }

  exportCSV(consolidatedId, payload: ExportConsolidatedCommissionsTranslationsPayloadModel, zoneId?) {
    const api = this.ConsolidateCommissionsApi.actions.exportCSV;
    return this.$$call(api, {zoneId: zoneId}, payload, {id: consolidatedId});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$consolidatedCommission().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.commissions')
  .service('consolidatedCommissionRequestsService', ConsolidatedCommissionRequestsService);
